import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import productQuery from '~/graphql/product.gql';
import productVariantsQuery from '~/graphql/product/variants.gql';
import productImagesQuery from '~/graphql/product/images.gql';
import productCarouselsQuery from '~/graphql/product-carousels.gql';

function fetchProductNav(_x, _x2) {
  return _fetchProductNav.apply(this, arguments);
}

function _fetchProductNav() {
  _fetchProductNav = _asyncToGenerator(function* (context, reference) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "/nav/nav-api/product/".concat(locale.market, "/").concat(locale.language, "/p/slug-").concat(reference, ".htm");

    try {
      const {
        data
      } = yield context.$axios.get(xhrUri);
      return data;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductNav.apply(this, arguments);
}

function fetchProductCarousels(_x3, _x4) {
  return _fetchProductCarousels.apply(this, arguments);
}

function _fetchProductCarousels() {
  _fetchProductCarousels = _asyncToGenerator(function* (context, reference) {
    let profileId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let exclude = arguments.length > 3 ? arguments[3] : undefined;
    const locale = context.state.i18n.currentLocale.iso;
    const withBrand = process.client && context.$cookies.get('product-brand') === 1;

    try {
      const {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productCarouselsQuery,
        variables: {
          profileId,
          reference,
          locale,
          exclude,
          withBrand
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductCarousels.apply(this, arguments);
}

function fetchProduct(_x5, _x6) {
  return _fetchProduct.apply(this, arguments);
}

function _fetchProduct() {
  _fetchProduct = _asyncToGenerator(function* (context, reference) {
    let profileId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const locale = context.state.i18n.currentLocale.iso;
    const withBrand = process.client && context.$cookies.get('product-brand') === 1;

    try {
      const {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productQuery,
        variables: {
          profileId,
          reference,
          locale,
          withBrand
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProduct.apply(this, arguments);
}

function fetchProductVariants(_x7, _x8) {
  return _fetchProductVariants.apply(this, arguments);
}

function _fetchProductVariants() {
  _fetchProductVariants = _asyncToGenerator(function* (_ref, reference) {
    let {
      app,
      getters
    } = _ref;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productVariantsQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductVariants.apply(this, arguments);
}

function fetchProductImages(_x9, _x10) {
  return _fetchProductImages.apply(this, arguments);
}

function _fetchProductImages() {
  _fetchProductImages = _asyncToGenerator(function* (_ref2, reference) {
    let {
      app,
      getters
    } = _ref2;
    const locale = getters['i18n/locale'].iso;

    try {
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productImagesQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchProductImages.apply(this, arguments);
}

export { fetchProduct, fetchProductCarousels, fetchProductVariants, fetchProductImages, fetchProductNav };